import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import {
  TELEMETRIA,
  DESCARGA_TERMINAL,
  MODULO_FERROVIA,
} from '~/constants/modules';
import { can, t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteTerminal,
  findTerminal,
  recordFiltering,
} from '~/store/modules/terminal/actions';

import Form from './form';

function TerminalList() {
  const redux = useSelector((state) => state.terminal);

  const statusInativeActive = [
    { label: 0, value: t('s.geral.opcoes.nao') },
    { label: 1, value: t('s.geral.opcoes.sim') },
  ];

  const statusConcentrador = [
    { label: 0, value: t('s.geral.opcoes.semconcentrador') },
    { label: 1, value: 'CBC' },
    { label: 2, value: 'Horustech' },
    { label: 3, value: 'Concentradora Abastek' },
  ];

  const tipohorustech = [
    { label: 0, value: 'Padrão - TCA direto' },
    { label: 1, value: 'Servidor - TCA mestre do posto' },
    { label: 2, value: 'Cliente - TCA cliente do TCA mestre' },
  ];

  const header = useMemo(
    () => [
      {
        id: 'idterminal',
        label: t('s.configuracao.terminal.idterminal'),
        filter: { type: 'text' },
      },
      {
        id: 'codigonomeposto',
        label: t('s.geral.postocomboio'),
        filter: { type: 'text' },
      },
      {
        id: 'versaofirmwareterminal',
        label: t('s.geral.camposistema.versaofirmwareterminal'),
        filter: { type: 'text' },
      },
      {
        id: 'modeloterminal',
        label: t('s.relatorio.reldesempenhomodeloveiculo.modelo'),
        filter: { type: 'text' },
      },
      {
        id: 'versaotelemetriaterminal',
        label: t('s.geral.versaotelemetriaterminal'),
        filter: { type: 'text' },
      },
      {
        id: 'buildtelemetriaterminal',
        label: t('s.geral.buildtelemetriaterminal'),
        filter: { type: 'text' },
      },

      {
        id: 'tipoconcentrador',
        label: t('s.configuracao.terminal.tipoconcentrador'),
        formatted: (v) =>
          statusConcentrador.find((p) => p.label === v)?.value || '',
        filter: { type: 'select', options: statusConcentrador },
      },

      {
        id: 'tipoconcentradormodorede',
        label: t('s.configuracao.terminal.tipoconcentradormodorede'),
        formatted: (v) => tipohorustech.find((p) => p.label === v)?.value || '',
        filter: { type: 'select', options: tipohorustech },
      },
    ],
    []
  );

  // campos impressao pdf ou excel

  const fieldlist = [
    'idterminal',
    'codigonomeposto',
    'versaofirmwareterminal',
    'duassaidasbicoterminal',
    'modeloterminal',
    'versaotelemetriaterminal',
    'buildtelemetriaterminal',
    'tipoterminal',
  ];

  if (can(MODULO_FERROVIA)) {
    fieldlist.push(
      'pedepercentualtanqueterminal',
      'leitordlocterminal',
      'sinalbypassterminal',
      'controlelinhaabastecimentoterminal',
      'hostcontrolevazaoterminal',
      'portacontrolevazaoterminal'
    );
  }

  fieldlist.push('portaterminal');

  if (can(TELEMETRIA)) {
    fieldlist.push('controlatelemetriaterminal');
  }

  if (can(DESCARGA_TERMINAL)) {
    fieldlist.push(
      'tiporecebimentoterminal',
      'solicitacnpjdistrecebimentoterminal',
      'solicitacnpjtransprecebimentoterminal',
      'solicitaplacactrecebimentoterminal',
      'solicitavalorNFrecebimentoterminal'
    );
  }

  fieldlist.push(
    'tipoconcentrador',
    'tipoconcentradormodorede',
    'ipcbcterminal',
    'portacbcterminal',
    'controlalcterminal',
    'leitorinternoterminal',
    'exigetagfimliberaterminal',
    'pedepredeterminacaoterminal',
    'usaimpressoraterminal',
    'viasimpressaoterminal',
    'tipoimpressaoveiculoterminal'
  );

  const substituirHeader = {
    codigonomeposto: t('s.geral.postocomboio'),
    duassaidasbicoterminal: t('s.configuracao.terminal.duassaidasbicoterminal'),
    tipoterminal: t('s.configuracao.terminal.tipoterminal'),
    leitordlocterminal: t('s.configuracao.terminal.leitordlocterminal'),
    sinalbypassterminal: t('s.configuracao.terminal.sinalbypassterminal'),
    controlelinhaabastecimentoterminal: t(
      's.cadastro.terminal.controlelinhaabastecimentoterminal'
    ),
    portaterminal: t('s.configuracao.terminal.portaterminal'),
    tipoconcentrador: t('s.configuracao.terminal.tipoconcentrador'),
    controlalcterminal: t('s.configuracao.terminal.controlalcterminal'),
    leitorinternoterminal: t('s.configuracao.terminal.leitorinternoterminal'),
    exigetagfimliberaterminal: t(
      's.configuracao.terminal.exigetagfimliberaterminal'
    ),
    idterminal: t('s.configuracao.terminal.idterminal'),
    versaofirmwareterminal: t('s.geral.camposistema.versaofirmwareterminal'),
    modeloterminal: t('s.relatorio.reldesempenhomodeloveiculo.modelo'),
    versaotelemetriaterminal: t('s.geral.versaotelemetriaterminal'),
    buildtelemetriaterminal: t('s.geral.buildtelemetriaterminal'),
    tipoconcentradormodorede: t(
      's.configuracao.terminal.tipoconcentradormodorede'
    ),
    controlatelemetriaterminal: t('s.configuracao.terminal.telemetriaterminal'),
    pedepercentualtanqueterminal: t('s.geral.pedepercentualtanqueterminal'),
    tiporecebimentoterminal: t(
      's.configuracao.terminal.tiporecebimentoterminal'
    ),
    solicitacnpjdistrecebimentoterminal: t(
      's.configuracao.terminal.solicitacnpjdistrecebimentoterminal'
    ),
    hostcontrolevazaoterminal: t(
      's.cadastro.terminal.hostcontrolevazaoterminal'
    ),
    portacontrolevazaoterminal: t(
      's.cadastro.terminal.portacontrolevazaoterminal'
    ),
    solicitacnpjtransprecebimentoterminal: t(
      's.configuracao.terminal.solicitacnpjtransprecebimentoterminal'
    ),
    solicitaplacactrecebimentoterminal: t(
      's.configuracao.terminal.solicitaplacactrecebimentoterminal'
    ),
    solicitavalorNFrecebimentoterminal: t(
      's.configuracao.terminal.solicitavalorNFrecebimentoterminal'
    ),
    ipcbcterminal: t('s.configuracao.terminal.ipcbcterminal'),
    portacbcterminal: t('s.configuracao.terminal.portacbcterminal'),
    pedepredeterminacaoterminal: t(
      's.geral.camposistema.volumepredeterminadomovimentacao'
    ),
    usaimpressoraterminal: t('s.configuracao.terminal.usaimpressoraterminal'),
    viasimpressaoterminal: t('s.configuracao.terminal.viasimpressaoterminal'),
    tipoimpressaoveiculoterminal: t(
      's.configuracao.terminal.tipoimpressaoveiculoterminal'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findTerminal}
      remove={deleteTerminal}
      form={Form}
      keys={['idterminal', 'idposto']}
      detach="idterminal"
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'terminais',
          formato,
          fields: fieldlist,
          redux,
          headers: substituirHeader,
          title: 'Relatório de Terminais',
          compactQuery: true,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          ignorarFormatacao: { portaterminal: true },
          substituirValores: {
            duassaidasbicoterminal: {
              '0': t('s.geral.opcoes.nao'),
              '1': t('s.geral.opcoes.sim'),
            },
            tipoterminal: {
              '0': 'BOPLA',
              '3': 'TCA3XX',
              '4': 'TCA3XX_FERROVIA',
            },
            pedepercentualtanqueterminal: {
              '0': t('s.geral.opcoes.nao'),
              '1': t('s.geral.opcoes.sim'),
            },
            tipoconcentrador: {
              '0': t('s.geral.opcoes.semconcentrador'),
              '1': 'CBC',
              '2': 'Horustech',
              '3': 'Concentradora Abastek',
            },
            leitordlocterminal: {
              '0': t('s.geral.opcoes.nao'),
              '1': t('s.geral.opcoes.sim'),
            },
            controlelinhaabastecimentoterminal: {
              '0': t('s.geral.controlelinhaabastecimentoterminal.semcontrole'),
              '1': t('s.geral.controlelinhaabastecimentoterminal.remoto'),
              '2': t('s.geral.controlelinhaabastecimentoterminal.local'),
            },
            controlalcterminal: {
              '0': t('s.geral.opcoes.nao'),
              '1': t('s.geral.opcoes.sim'),
            },
            sinalbypassterminal: {
              '0': t('s.geral.opcoes.nao'),
              '1': t('s.geral.opcoes.sim'),
            },
            leitorinternoterminal: {
              '0': t('s.geral.opcoes.nao'),
              '1': 'Micro Reader',
              '2': 'Quantum IS 3480',
              '3': 'Akiyama CI05',
              '4': 'RFIDCC RFEasy',
              '5': 'Abastek Híbrido',
              '6': 'HID',
            },
            exigetagfimliberaterminal: {
              N: t('s.geral.opcoes.nao'),
              S: t('s.geral.opcoes.sim'),
            },
            tiporecebimentoterminal: {
              N: t('s.geral.opcoes.nao'),
              O: t('s.operacao.abastecimento.onlinemovimentacao'),
              F: t(
                's.configuracao.terminal.onlineofflinetiporecebimentoterminal'
              ),
              G: t('s.configuracao.terminal.offlinetiporecebimentoterminal'),
              '0': t('s.geral.opcoes.nao'),
              '1': t('s.configuracao.terminal.offlinetiporecebimentoterminal'),
            },
            versaotelemetriaterminal: {
              '0': t('s.configuracao.terminal.semtelemetria'),
              '2': t('s.configuracao.terminal.rs485terminal'),
              '3': t('s.configuracao.terminal.conversorserial'),
            },
            tipoconcentradormodorede: {
              '0': 'Padrão - TCA direto',
              '1': 'Servidor - TCA mestre do posto',
              '2': 'Cliente - TCA cliente do TCA mestre',
            },
          },
        })
      }
    />
  );
}

export default TerminalList;
